import { ClearUser } from "../../Redux/UserSlice/userSlice";
import { sendPostCallToSever } from "../Axios/Axios";
import { auth } from "../../Config/firebase-config";
import { ClearAuth, setAuthToken } from "../../Redux/AuthSlice/authSlice";
import { ClearImage } from "../../Redux/MainImage/imageSlice";
import { deleteAll } from "../../Redux/WaterMarks/wateramarks";

const LoginAPI = () => (dispatch) => {
  return sendPostCallToSever({}, "users/login").then(async (result) => {
    var data = result.data;
    // dispatch(setUserVerify(data))
    if (data) {
      const authToken = await RefreshToken();
      dispatch(setAuthToken(authToken));

      return data;
    } else return false;
  });
};

const RefreshToken = () => {
  return auth.currentUser
    .getIdTokenResult(true)
    .then((idTokenResult) => {
      const refreshedToken = idTokenResult.token;
      return refreshedToken;
    })
    .catch((error) => {
      // Handle error refreshing token
      console.log("refreshed error", error);
    });
};

const Logout = () => (dispatch) => {
  dispatch(ClearImage());
  dispatch(deleteAll());
  dispatch(ClearUser());
  dispatch(ClearAuth());
};

export { LoginAPI, RefreshToken, Logout };
